import UpdateOrderPricingModal from './UpdateOrderPricingModal.container'

export default UpdateOrderPricingModal
